import moment from "moment";

export function getStartOfWeek(currentDate) {
    let date = moment(currentDate, 'YYYY-MM-DD');
    if (!date.isValid()) {
        date = moment();
    }
    return date.startOf('isoWeek');
}
